import { createContext } from 'react';

export interface ThemeConfig {
  color: string;
  colorFill: string;
  textColorClassName?: string;
  className: string;
}

export interface ThemeContextValue {
  theme: string;
  setTheme: (theme: string) => void;
  config: ThemeConfig;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);
